import styled from "styled-components";
import {
  Button,
  Icon,
  SideMenu as ReactUiKitSideMenu,
  Heading,
} from "react-ui-kit";
import { FaWhatsappSquare, FaPhoneAlt } from "react-icons/fa";
import {
  TLogoStyles,
  TSocialStyle,
} from "../../@types/component/THeaderComponent";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px -5px 13px #000;
`;

export const BottomHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 36px;
  min-height: 79px;
  z-index: 999;
  background-color: ${({ theme }) =>
    theme.colors?.headerColor || theme.colors.primary};
  color: ${({ theme }) => theme.colors.textInPrimaryColor};
`;

export const PartnerName = styled(Heading)`
  font-size: 18px;
`;

export const MenuButtonIcon = styled(Button)`
  i {
    color: ${({ theme }) => theme.colors.icon};
  }
`;

export const MenuIcon = styled(Icon)``;

export const SideMenu = styled(ReactUiKitSideMenu)`
  i {
    color: ${({ theme }) => theme.colors.textInPrimaryColor} !important;
  }
`;

export const PartnerImg = styled.img.attrs((props: TLogoStyles) => ({
  src: typeof props.img === "string" ? props.img : props.img.url,
}))<TLogoStyles>`
  width: ${({ img }) => (typeof img === "string" ? "124px" : img.width)};
  height: ${({ img }) => (typeof img === "string" ? "40px" : img.height)};
`;

export const TopHeader = styled.div`
  display: flex;
  flex-direction: row;

  @media (min-width: 768px) {
    height: 37px;
  }

  & > div:first-child {
    display: none;
    @media (min-width: 768px) {
      display: block;
      background-color: #dadada;
      padding-left: 36px;
      width: 40%;
    }
  }

  & > div:last-child {
    width: 100%;
    padding: 10px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.secundary};
    @media (min-width: 768px) {
      justify-content: flex-end;
      padding-right: 36px;
      padding-left: 0px;
      position: relative;
      min-width: 670px;
      width: 60%;
    }
  }
`;

export const Trapezoid = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
    position: absolute;
    left: -22px;
    top: 0px;
    border-top: 50px solid ${({ theme }) => theme.colors.secundary};
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
  }
`;

export const SocialContainer = styled.div<TSocialStyle>`
  display: flex;
  align-items: center;
  margin: 2px 10px;
  cursor: ${({ cursor }) => cursor || "default"};
  @media (min-width: 768px) {
    margin: 0 10px;
  }
  p {
    font-family: "Open Sans";
    font-weight: bold;
    color: ${({ theme }) => theme.colors.textInSecundaryColor};
    font-size: 12px;
    @media (min-width: 425px) {
      font-size: 13px;
    }
  }
`;

export const WhatsAppIcon = styled(FaWhatsappSquare)`
  color: ${({ theme }) => theme.colors.textInSecundaryColor};
  font-size: 20px;
  margin-right: 5px;
`;

export const PhoneIcon = styled(FaPhoneAlt)`
  color: ${({ theme }) => theme.colors.textInSecundaryColor};
  font-size: 20px;
  margin-right: 5px;
`;
